import { action, flow, makeAutoObservable, makeObservable, observable } from "mobx";
import { InputOnChangeData } from "semantic-ui-react";
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { RootStore } from "../../../stores/RootStore";
import { CalibraService } from "../../../services/calibra.service";
import { Manufacturer } from "../../../models/manufacturer";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export class ManufacturerStore {
    manufacturerItems: Array<Manufacturer> = [];
    columnDef: Array<ColDef>;
    isItemOpen: boolean = false;
    selectedManufacturerItem: Manufacturer = new Manufacturer();
    CalibraService: CalibraService;
    temporaryName: string = "";
    temporaryIsActive: boolean = false;
    private RootStore: RootStore;
    yesNoDatasource: Array<any>;
    constructor(rootStore: RootStore) {
        this.RootStore = rootStore;
        makeAutoObservable(this, {
            manufacturerItems: observable,
            columnDef: observable,
            isItemOpen: observable,
            temporaryName: observable,
            temporaryIsActive: observable,
            selectedManufacturerItem: observable,
            setItemOpenTrue: action,
            setItemOpenFalse: action,
            openSelectedItem: action,
            updateManufacturerItem: action,
            saveManufacturer: flow,
            getManufacturers: flow,
        })

        this.CalibraService = new CalibraService();

        this.columnDef = [
            {
                field: 'edit', headerName: 'Megtekintés', maxWidth: 120, minWidth: 120,
                cellRenderer: 'btnCellRendererOpenItem',
                cellRendererParams: {
                    clicked: (data: any) => { this.openSelectedItem(data.Id); },
                }
            },
            { field: 'Name', headerName: 'Megnevezés', filter: 'agSetColumnFilter', minWidth: 300, sortable: true },
            { field: 'IsActive', headerName: 'Aktív', filter: 'agSetColumnFilter', valueFormatter: params => this.booleanFormatter(params), minWidth: 100, sortable: true },
            // {
            //     field: '', headerName: 'Eltávolítás', maxWidth: 100, minWidth: 100,
            //     cellRenderer: 'btnDeleteCellRenderer',
            //     cellRendererParams: {
            //         clicked: (data: any) => { this.InactivateManufacturer(data); },
            //     }

            // },
        ]

        this.yesNoDatasource = [
            { value: 0, text: 'Inaktív' },
            { value: 1, text: 'Aktív' },
        ]
    }

    booleanFormatter = (params: any) => {        
        return params != null && params.data != null ? (params.data.IsActive == true ? "Aktív" : "Inaktív") : "";
    }

    updateManufacturerItem = (value: string) => {
        this.temporaryName = value;
    }

    updateManufacturerItemIsActive = (value: number) => {
        console.log('updateManufacturerItemIsActiv', value)
        if (value === 1) {
            this.temporaryIsActive = true;
        }        
        else {
            this.temporaryIsActive = false;
        }
    }

    setItemOpenTrue = () => {
        this.isItemOpen = true;
    }

    setItemOpenFalse = () => {
        this.isItemOpen = false;
    }

    openSelectedItem = (itemId: number) => {
        this.isItemOpen = true;
        if (itemId > 0) {
            var item = this.manufacturerItems.find(x => x.Id == itemId)
            this.selectedManufacturerItem = item;
        }
        else {
            this.selectedManufacturerItem = new Manufacturer();
            this.selectedManufacturerItem.Name = "";
        }
        this.temporaryName = this.selectedManufacturerItem.Name;
        this.temporaryIsActive = this.selectedManufacturerItem.IsActive;
    }

    * saveManufacturer() {
        this.setItemOpenFalse();
        this.selectedManufacturerItem.Name = this.temporaryName;
        this.selectedManufacturerItem.IsActive = this.temporaryIsActive;
        this.RootStore.addloading('saveManufacturer');
        yield this.CalibraService.SaveManufacturer(this.selectedManufacturerItem);
        this.RootStore.removeLoading('saveManufacturer');
        this.getManufacturers();
    }
    // * InactivateManufacturer(data: any) {
    //     if (confirm("Biztosan törölni akarod a gyártót?")) {
    //         this.setItemOpenFalse();

    //         this.RootStore.addloading('saveManufacturer');
    //         yield this.CalibraService.InactivateManufacturer(data);
    //         this.RootStore.removeLoading('saveManufacturer');
    //         this.getManufacturers();
    //     }
    // }
    * getManufacturers() {
        this.RootStore.addloading('getManufacturers');
        this.manufacturerItems = yield this.CalibraService.GetManufacturers();

        this.RootStore.removeLoading('getManufacturers');
    }



    get getVodafoneCommissionItemCanBeSaved() {
        // if (this.temporaryDiscount0_5Number === null || this.temporaryDiscount5_25Number === null || this.temporaryDiscount25_50Number === null || this.temporaryDiscount50_InfNumber === null ||
        //     this.temporaryDiscount0_5Number < 0 || this.temporaryDiscount5_25Number < 0 || this.temporaryDiscount25_50Number < 0 || this.temporaryDiscount50_InfNumber < 0) {
        //         return false;
        //     }

        return true;
    }
}